var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activity-feed',{attrs:{"extra-params":'?profile=' + this.$route.params.username,"type":"profile"}})
}
var staticRenderFns = []

export { render, staticRenderFns }